import type { SmileSimulationController } from "../hooks/useSmileSimulationController";
import { getSmileSimulationCopy } from "../model/i18n";
import type { SmileSimulationLanguage } from "../model/types";

type SmileSimulationPatientSummaryProps = {
  caption?: string;
  isExperience?: boolean;
  language: SmileSimulationLanguage;
  patient: NonNullable<SmileSimulationController["patient"]["current"]>;
};

export function SmileSimulationPatientSummary({
  caption,
  isExperience = false,
  language,
  patient,
}: SmileSimulationPatientSummaryProps) {
  const copy = getSmileSimulationCopy(language);

  return (
    <div className="bg-white/88 w-full rounded-[1.5rem] border border-white/70 p-4 shadow-[0_16px_40px_rgba(17,17,17,0.06)] backdrop-blur-sm">
      {caption ? (
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#8F14E5]/70">
          {caption}
        </p>
      ) : null}
      <div className="mt-2 flex items-center justify-between gap-4">
        <div>
          {isExperience ? (
            <p className="text-base font-semibold text-[#1f1230]">
              {patient.chartNumber}
            </p>
          ) : (
            <>
              <p className="text-base font-semibold text-[#1f1230]">
                {patient.name}
              </p>
              <p className="text-sm text-[#6b577d]">
                {copy.summary.chartNo} {patient.chartNumber}
              </p>
            </>
          )}
        </div>
        {!isExperience ? (
          <div className="rounded-full bg-[#f3e8ff] px-3 py-1 text-xs font-semibold text-[#7c3aed]">
            {copy.summary.patient}
          </div>
        ) : null}
      </div>
    </div>
  );
}
